const { initializeApp } = require("firebase/app");
const { getFirestore } = require("firebase/firestore");
const { getAuth } = require("firebase/auth");


const firebaseConfig = {
  apiKey: "AIzaSyBi72vjQzkgf5oRqpH4oTQ-u1YpDs8-dF8",
  authDomain: "ontime-972c6.firebaseapp.com",
  projectId: "ontime-972c6",
  storageBucket: "ontime-972c6.appspot.com",
  messagingSenderId: "839844222847",
  appId: "1:839844222847:web:e1e6f7f4576b8f6300ec4a",
  measurementId: "G-KB4LP98BBG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
const auth = getAuth(app);
module.exports = { db, auth };